import React, { PureComponent } from 'react';
import axios from 'axios';
import Select from 'react-select';
import appConstant from '../../../constants/app';
import validationFunctions from '../../utils/validations/index';
import validationMessages from '../../utils/validations/messages';

class InputSearch extends PureComponent {
  state = {
    keyword: '',
    options: [],
    value: this.props.value,
    errorMessage: null,
  }
  
  onKeyPress = (e,attr) => {  
    if(attr.action === 'input-change'){
      this.setState({keyword: e},()=>{
        this.validate(this.state.keyword)
      })
    }
  
    if (e.length >= 3) {  
      let url = `${appConstant.API_URL}/link/search?key=${e}`;
      axios.get(url)
        .then(res => {
          const options = Object.assign({}, {data: res.data.links});
          this.setState({ options: options.data })
        }).catch(err => {
          if(!this.state.value.id) this.validate(null)          
        });
    }
  };

  onChange = ({ id, label }) => {
    this.props.value.id = id
    this.props.value.label = label
  };

  validate = (value = this.props.value, explicitErrorMessage) => {
    if(value == null){
      this.setState({
        errorMessage: explicitErrorMessage,
      });
    }
    const {
      validationRules,
      customErrorMessage
    } = this.props;

    let valid = true;
    let errorMessage = '';
    const rules= validationRules;
    const rulesList = rules && rules.split('|');
    const customErrorMessageArr = customErrorMessage && customErrorMessage.split('|');

    let errorCounter = 0;

    rulesList && rulesList.some((ruleParam, index) => {
      if (errorCounter > 0) return false;

      const ruleSplit = ruleParam.split(':');
      const rule = ruleSplit[0];
      const parameters = (ruleSplit[1] || '').split(',');


      if (validationFunctions[rule] && !validationFunctions[rule].apply(null, [value, ...parameters])) {
        errorCounter += 1;
        errorMessage = (customErrorMessageArr && customErrorMessageArr[index]) || validationMessages[rule];
        valid = valid && false;
      }

    });

    this.setState({
      errorMessage: errorMessage,
    });

    return valid;
  }

  render() {
    const {
      value,
      options,
      errorMessage,
    } = this.state;

    return (
      <div>
        <Select
          defaultValue={value}
          options={options}
          onInputChange={this.onKeyPress}
          onChange={this.onChange}
          filterOption={(option, filter) => {
            return option.data.url.includes(filter.toLowerCase())
              || option.label.toLowerCase().includes(filter.toLowerCase())
              || option.data.tags.filter(o => o.label.toLowerCase().includes(filter.toLowerCase())).length > 0
          }}
        />
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
    );
  }
}

export default InputSearch;



// WEBPACK FOOTER //
// ./src/app/components/complex/inputSearch.js